import * as React from 'react';
import { TradeSymbol } from '@shared/types/tsk';
import TradeIcon from '../../TradeIcon';

interface SymbolLayerProps {
    symbols: TradeSymbol[];
    scale: number;
    iconSize: number;
    scaleWithPlan: boolean;
    draggingSymbolId: string | null;
    selectionId: string | null;
    snappedSymbolId: string | null;
    isFaded?: boolean;
}

const SymbolLayer: React.FC<SymbolLayerProps> = ({
    symbols, scale, iconSize, scaleWithPlan, draggingSymbolId,
    selectionId, snappedSymbolId, isFaded
}) => {
    return (
        <div className={`absolute top-0 left-0 w-full h-full transition-opacity duration-300 ${isFaded ? 'opacity-40' : 'opacity-100'}`}>
            {symbols.map(symbol => (
                <div
                    key={symbol.id}
                    style={{
                        position: 'absolute',
                        left: symbol.position.x,
                        top: symbol.position.y,
                        transform: `translate(-50%, -50%) ${scaleWithPlan ? '' : `scale(${1 / scale})`}`,
                        zIndex: draggingSymbolId === symbol.id ? 100 : 10
                    }}
                    data-testid={`symbol-${symbol.id}`}
                    data-x={symbol.position.x}
                    data-y={symbol.position.y}
                >
                    <TradeIcon type={symbol.type} system={symbol.system} size={iconSize} />
                    {(selectionId === symbol.id || snappedSymbolId === symbol.id) && (
                        <div className={`absolute inset-0 ring-[3px] rounded-full -m-4 animate-pulse pointer-events-none ${snappedSymbolId === symbol.id ? 'ring-blue-400' : 'ring-white/80 shadow-[0_0_10px_rgba(255,255,255,0.5)]'}`} />
                    )}
                </div>
            ))}
        </div>
    );
};

export default React.memo(SymbolLayer);
